'use client';

import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';
import { Tab, TabGroup } from '@/components/ui/tabs';

interface DrawNavigationProps {
  currentTab: 'draws' | 'seedings';
  onTabChange: (tab: 'draws' | 'seedings') => void;
  className?: string;
}

export function DrawNavigation({ currentTab, onTabChange, className }: DrawNavigationProps) {
  const t = useTranslations('Event.navigation');

  return (
    <TabGroup variant="subtle" className={cn('w-fit shrink-0', className)}>
      <Tab
        className="min-h-11"
        active={currentTab === 'draws'}
        aria-pressed={currentTab === 'draws'}
        onClick={() => onTabChange('draws')}
      >
        {t('drawView')}
      </Tab>
      <Tab
        className="min-h-11"
        active={currentTab === 'seedings'}
        aria-pressed={currentTab === 'seedings'}
        onClick={() => onTabChange('seedings')}
      >
        {t('seedings')}
      </Tab>
    </TabGroup>
  );
}
